<template>
  <div class="monitor">
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>{{ this.$store.state.titles }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <el-card>
        <el-form :inline="true"
                 :model="formInline"
                 class="demo-form-inline">
          <div>
            <el-form-item label="订单编号：">
              <el-input v-model="formInline.order_sn"
                        placeholder="请输入订单编号"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="支付方式：">
              <el-select v-model="formInline.code"
                         placeholder="请选择支付方式"
                         clearable>
                <el-option label="微信"
                           value="WeChat"> </el-option>
                <el-option label="支付宝"
                           value="AliPay"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间：">
              <el-date-picker v-model="formInline.date"
                              type="datetimerange"
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              value-format="yyyy-MM-dd hh-mm-ss">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button @click="reset">重 置</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="getList">查 询</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-card>
      <el-card>
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane label="账单列表"
                       name="first"></el-tab-pane>
          <el-tab-pane label="待支付"
                       name="second"></el-tab-pane>
        </el-tabs>
        <div class="table">
          <el-table :data="tableData"
                    style="width: 100%"
                    border
                    v-loading="load">
            <el-table-column align="center"
                             width="220"
                             prop="order_sn"
                             label="订单编号"> </el-table-column>
            <el-table-column align="center"
                             width="220"
                             prop="origin"
                             label="账单类型"> </el-table-column>
            <el-table-column align="center"
                             width="220"
                             prop="subject_name"
                             label="付费产品"> </el-table-column>
            <el-table-column align="center"
                             width="220"
                             prop="amount"
                             label="单价"> </el-table-column>
            <el-table-column align="center"
                             width="220"
                             prop="amount"
                             label="支付金额 (元)"> </el-table-column>
            <el-table-column align="center"
                             width="220"
                             prop="out_pay"
                             label="支付方式"> </el-table-column>
            <el-table-column align="center"
                             width="220"
                             prop="create_time"
                             label="订单创建时间"> </el-table-column>
            <el-table-column align="center"
                             width="220"
                             prop="pay_time"
                             label="支付时间"> </el-table-column>
            <el-table-column align="center"
                             prop="order_status"
                             label="状态"
                             width="220">
              <template slot-scope="{ row }">
                <span class=" dot"
                      v-if="row.status == '待支付'"></span>
                <span class="dot1"
                      v-if="row.status == '已支付'"></span>
                <span v-if="row.status == '支付失败'"></span>
                <span>{{ row.status  }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             label="操作"
                             width="220"
                             fixed="right">
              <template slot-scope="{ row }">
                <div class="link">
                  <el-link type="primary"
                           @click="operate( row.id)">详情</el-link>
                  <!--  <el-link type="primary"
                           @click="operate('product', 'delete', row.id)"
                           v-if="row.status == '待支付'">去支付</el-link> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pageSize">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="page"
                         :page-sizes="[10, 20, 30, 40]"
                         :page-size="size"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </el-card>
    </div>
    <div v-if="billDetailsView">
      <billDetails @closeModel='initcloseModel' :did='did'>

      </billDetails>
    </div>

  </div>
</template>

<script>
import billDetails from './common/billDetails.vue'
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      total: 0,
      page: 1,
      size: 10,
      status: 0,
      load: false,
      did: '',
      billDetailsView: false,
      activeName: "first",
      tableData: [],
      formInline: {
        order_sn: "",
        code: "",
        date: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  components: { billDetails },
  async created () {
    await this.getList(1);
  },
  methods: {
    ...mapActions({
      getPayment: "detect/getPayment", //产品列表
      getPaymentD: "detect/getPaymentD", //产品列表
    }),
    initcloseModel () {
      this.billDetailsView = false
    },
    reset () {
      this.formInline = {
        order_sn: "",
        code: "",
        date: [],
      };
      this.getList(1);
    },
    /* ${opt.id} */
    // 获取列巴
    getList (tag) {
      this.load = true;
      let params = {
        token: this.getToken, //用户token
        page: tag == 1 ? tag : this.page, //当前页数
        size: this.size, //每页显示条数
        order_sn: this.formInline.order_sn,
        code: this.formInline.code,
        status: this.status,
        start_time: this.formInline.date ? this.formInline.date[0] : null,
        end_time: this.formInline.date ? this.formInline.date[1] : null,
      };
      this.getPayment(params).then(({ data }) => {
        this.load = false;
        if (data.code == 1) {
          this.tableData = data.data.list;
          this.total = data.data.count;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 详情
    operate (id) {
      console.log(id,'id')
      this.billDetailsView = true
      this.did = id

    },
    handleClick (val) {
      this.status = val.index
      this.tableData = [];
      this.getList();
    },
    handleSizeChange (val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.monitor {
  .title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
  }
  .main {
    min-width: 1200px;
    margin: 20px;
    .demo-form-inline {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .el-card {
      margin-top: 10px;
      &:first-child {
        margin-top: 0;
      }
    }
    ::v-deep .el-form--inline .el-form-item {
      margin: 10px 10px 10px 0;
    }
    .table {
      min-height: 500px;
    }
  }
  .pageSize {
    text-align: right;
    margin-top: 20px;
  }
}
::v-deep .el-table--border th.el-table__cell {
  background-color: #f8f9fe;
}
.link {
  a {
    margin: 0 8px;
  }
}
.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f00;
  transform: translateY(-2px);
  margin-right: 4px;
}
.dot1 {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #23ca18;
  transform: translateY(-2px);
  margin-right: 4px;
}
</style>